import { FilterModel } from '@utils/hooks/use-app-search-params.ts';

export function getFilterTypeFromGridToApi(
  filterType: string,
  filterValue: string
): Array<string> {
  switch (filterType) {
    case 'equals':
      return ['eq', filterValue];
    case 'contains':
      return ['ilike', `%${filterValue}%`];
    default:
      return ['ilike', `%${filterValue}%`];
  }
}

export function getEncodedFilters(filters: FilterModel): string {
  if (!filters || Object.keys(filters).length === 0) {
    return '';
  }

  return Object.keys(filters)
    .map(key => {
      const filter = filters[key];
      return encodeURIComponent(`${key}:${filter.type}:${filter.value}`);
    })
    .join('&');
}
